import { render, staticRenderFns } from "./ListCarstock.vue?vue&type=template&id=bc6a6158&"
import script from "./ListCarstock.vue?vue&type=script&lang=js&"
export * from "./ListCarstock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports